export const meta = { id: 'O18', slug: 'criar-jornada', title: 'Como criar uma Jornada', description: 'Crie um percurso e organize as experiências que levarão o participante ao resultado esperado.', profile: 'owner', category: 'jornadas', type: 'task', status: 'published', order: 480, keywords: ['criar jornada','trilha','percurso','conteúdos'], previous: 'O17', next: 'O19', related: ['O17','O19','A05'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como criar uma Jornada

Antes de estruturar a Jornada, defina onde o participante deve chegar.

<HelpImage pendingId="O18.1" alt="Tela de criação ou edição de Jornada" />

<Steps>
  <Step title="Crie a Jornada">Informe os dados disponíveis para identificá-la.</Step>
  <Step title="Adicione ou vincule experiências">Inclua os elementos que farão parte do percurso.</Step>
  <Step title="Organize a ordem">Defina uma sequência coerente de desenvolvimento.</Step>
  <Step title="Revise a experiência">Observe se o participante entende o que já fez e qual é o próximo passo.</Step>
</Steps>
